<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="headingBor">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseBor" aria-expanded="false" aria-controls="collapseBor">
                Bedrijfsopvolgingsregeling
            </button>
        </h2>
        <div id="collapseBor" class="accordion-collapse collapse" aria-labelledby="headingBor"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                De bedrijfsopvolgingsregeling (BOR) is een fiscale faciliteit in de Nederlandse schenkingsbelasting die
                bedoeld is om de continuïteit van ondernemingen te waarborgen bij overdracht van een bedrijf. Bij een
                schenking van een (gedeelte van een) onderneming kan onder voorwaarden een vrijstelling van
                schenkbelasting worden verkregen. Deze regeling voorkomt dat opvolgers (bijvoorbeeld kinderen)
                geconfronteerd worden met een hoge belastingdruk die de voortzetting van het bedrijf in gevaar zou
                kunnen brengen.
                <div class="space20"></div>
                De BOR geldt onder andere voor eenmanszaken, vennootschappen onder firma en aandelen in
                een bv die een onderneming drijft.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingBor2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseBor2" aria-expanded="false" aria-controls="collapseBor2">
                Voortzetting
            </button>
        </h2>
        <div id="collapseBor2" class="accordion-collapse collapse" aria-labelledby="headingBor2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Om gebruik te maken van de bedrijfsopvolgingsregeling (BOR), moet de ontvanger de onderneming minstens 3
                jaar voortzetten. Dit wordt het voortzettingsvereiste genoemd. Als deze (een deel van) de onderneming
                binnen 3 jaar verkoopt, voldoet deze niet meer aan de voorwaarden. Dit geldt ook als de aard van de
                bedrijfsactiviteiten binnen 3 jaar verandert. De ontvanger kan dan geen beroep meer doen op de BOR.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingBor3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseBor3" aria-expanded="false" aria-controls="collapseBor3">
                Beleggingsvermogen
            </button>
        </h2>
        <div id="collapseBor3" class="accordion-collapse collapse" aria-labelledby="headingBor3"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Het deel van de ondernemingswaarde dat bestaat uit beleggingen is de waarde van het
                beleggingsvermogen dat behoort bij de gehele onderneming. Beleggingsvermogen kwalificeert namelijk niet
                voor de bedrijfsopvolgingsregeling.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingBor13">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseBor13" aria-expanded="false" aria-controls="collapseBor13">
                Brochure Belastingdienst "Erfbelasting en schenkbelasting en de bedrijfsopvolgingsregeling"
            </button>
        </h2>
        <div id="collapseBor13" class="accordion-collapse collapse" aria-labelledby="headingBor13"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                De Belastingdienst heeft een uitgebreide brochure over wat de bedrijfsopvolgingsregeling= inhoudt en hoe
                je er gebruik van kunt maken.
                <div class="space20"></div>
                <snelstart-ui-button size="small" type="secondary"
                                     iconRight="arrow-up-right-from-square">

                    <a target="_blank"
                       href="https://www.belastingdienst.nl/wps/wcm/connect/bldcontentnl/themaoverstijgend/brochures_en_publicaties/erf-en-schenkbelasting-en-de-bedrijfsopvolgingsregeling">
                        Fiscale informatie erfbelasting en schenkbelasting en de bedrijfsopvolgingsregeling
                    </a>

                </snelstart-ui-button>
            </div>
        </div>
    </div>


</div>
